module.exports = __webpack_public_path__ + "img/spaceman.95f84509.png";